import React, { useState } from 'react';
import '../styles/Sidebar.css';

interface SidebarProps {
  activePrograms: string[];
  inactivePrograms?: string[];
  onSelect: (code: string) => void;
  currentLang: 'es' | 'en';
}

const Sidebar: React.FC<SidebarProps> = ({ activePrograms, inactivePrograms = [], onSelect, currentLang }) => {
  const [filter, setFilter] = useState<string>('');
  const filteredActive = activePrograms.filter(a => a.toLowerCase().includes(filter.toLowerCase()));
  const filteredInactive = inactivePrograms.filter(a => a.toLowerCase().includes(filter.toLowerCase()));

  return (
    <aside className="sidebar">
      <h2 className="sidebar-title">{currentLang === 'es' ? 'Conversaciones' : 'Programs'}</h2>
      <div className="search-wrap sidebar-search">
        <input
          placeholder={currentLang === 'es' ? 'Buscar…' : 'Search…'}
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        <svg viewBox="0 0 24 24" className="search-icon">
          <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-1.48 1.48l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/>
        </svg>
      </div>
      <nav className="sidebar-nav">
        <details className="sidebar-section" open>
          <summary className="sidebar-section-title">
            {currentLang === 'es' ? 'Todos' : 'Active'}
          </summary>
          <ul className="sidebar-list">
            {filteredActive.map(code => (
              <li key={code} className="sidebar-list-item">
                <button onClick={() => onSelect(code)}>{code}</button>
              </li>
            ))}
          </ul>
        </details>
        {filteredInactive.length > 0 && (
          <details className="sidebar-section">
            <summary className="sidebar-section-title">
              {currentLang === 'es' ? 'Eliminados' : 'Inactive'}
            </summary>
            <ul className="sidebar-list">
              {filteredInactive.map(code => (
                <li key={code} className="sidebar-list-item">
                  <button onClick={() => onSelect(code)}>{code}</button>
                </li>
              ))}
            </ul>
          </details>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar; 